import type { PropsWithChildren } from "react";
import { tv, type VariantProps } from "tailwind-variants";

export const BADGE_STATUS = {
  SUCCESS: "success",
  ERROR: "error",
  DEFAULT: "default",
  WARNING: "warning",
  INFO: "info",
} as const;

const badgeVariants = tv({
  base: "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
  variants: {
    /*
      Each pairing is contrast-checked in scripts/check-contrast.mjs; the previous
      50/600 pairings failed AA (amber sat at 2.5:1).
    */
    status: {
      [BADGE_STATUS.DEFAULT]: "bg-surface-sunken text-content-muted ring-line-strong",
      [BADGE_STATUS.SUCCESS]: "bg-success-surface text-success-content ring-success/40",
      [BADGE_STATUS.WARNING]: "bg-warning-surface text-warning-content ring-warning/40",
      [BADGE_STATUS.ERROR]: "bg-danger-surface text-danger-content ring-danger/40",
      [BADGE_STATUS.INFO]: "bg-info-surface text-info-content ring-info/40",
    },
  },
  defaultVariants: {
    status: BADGE_STATUS.DEFAULT,
  },
});

type BadgeProps = {
  className?: string;
} & VariantProps<typeof badgeVariants>;

export const Badge = ({ children, className, status }: PropsWithChildren<BadgeProps>) => {
  return <span className={badgeVariants({ status, className })}>{children}</span>;
};
